import { useId } from 'react';

interface FieldA11yOptions {
  id?: string;
  describedBy?: string;
  helperText?: string;
  error?: string;
}

export const useFieldA11y = ({
  id,
  describedBy,
  helperText,
  error,
}: FieldA11yOptions) => {
  const generatedId = useId();
  const fieldId = id ?? generatedId;
  const helperId = helperText ? `${fieldId}-helper` : undefined;
  const errorId = error ? `${fieldId}-error` : undefined;
  const describedByIds = [describedBy, helperId, errorId]
    .filter(Boolean)
    .join(' ');

  return {
    fieldId,
    helperId,
    errorId,
    describedByIds: describedByIds || undefined,
  };
};
